import React from "react";
import { Box, Typography } from "@mui/material";

const WinnerLoserBox = ({ strategies = [], NAV_NUMBER }) => (
  <Box sx={{ width: "100%" }}>
    <Box
      sx={{
        height: "200px",
        overflowY: "auto",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f5f5f5",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#bdbdbd",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#9e9e9e",
        },
      }}
    >
      {strategies?.map((strategy, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 12px",
            borderBottom:
              index < strategies?.length - 1 ? "1px solid #f0f0f0" : "none",
            "&:hover": {
              backgroundColor: "#f8f9fa",
            },
            transition: "background-color 0.2s",
          }}
        >
          {/* Strategy Name Column */}
          <Typography
            sx={{
              width: "50%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontWeight: "bold",
              fontSize: "0.875rem",
              color: "#2c3e50",
              textAlign: "left",
            }}
          >
            {strategy.name}
          </Typography>

          {/* Dollar PnL Column */}
          <Typography
            sx={{
              width: "25%",
              textAlign: "right",
              fontWeight: "bold",
              fontSize: "0.875rem",
              color: strategy.pnl < 0 ? "#e53935" : "#43a047",
            }}
          >
            {strategy.pnl < 0
              ? `($${Math.abs(Math.round(strategy.pnl)).toLocaleString()})`
              : `$${Math.round(strategy.pnl).toLocaleString()}`}
          </Typography>

          {/* BPS Column */}
          <Typography
            sx={{
              width: "25%",
              textAlign: "right",
              fontWeight: "bold",
              fontSize: "0.875rem",
              color: strategy.pnl < 0 ? "#e53935" : "#43a047",
              paddingRight: "4px",
            }}
          >
            {strategy.pnl < 0
              ? `${((strategy.pnl / NAV_NUMBER) * 10000).toFixed(1)}`
              : `+${((strategy.pnl / NAV_NUMBER) * 10000).toFixed(1)}`}
            {" bps"}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

export default WinnerLoserBox;
